<template>
  <div class="header">
    <div class="block">
      <a
        href="https://www.derdachstein.at/de"
        target="_blank"
      >
        <img
          src="../assets/dachstein-logo.png"
          alt="dachstein-logo"
        >
      </a>
      <div class="headerleft">
        <a href="tel:+43 3687 22 0 42 800">
          <font-awesome-icon
            icon="phone"
            size="lg"
          />
          <p>Hotline</p>
        </a>
        <!-- LEFT HEADER -->
      </div>
      <div class="headerright">
        <div class="language-toggle">
          <a
            class="lang-link"
            :class="{'current-lang':currentLanguage==='de'}"
            :href="urlDe"
          >DE</a> | <a
            class="lang-link"
            :class="{'current-lang':currentLanguage==='en'}"
            :href="urlEn"
          >EN</a>
        </div>
        <!-- RIGHT HEADER -->
      </div>
    </div>
  </div>
</template>

<script>
import lang from "../i18n/index";

export default {
  name: 'Header',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      urlEn: window.location.origin + window.location.pathname + '?language=en',
      urlDe: window.location.origin + window.location.pathname + '?language=de',
      currentLanguage: lang.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  width: 100%;
  height: auto;
  padding: 1rem 1rem 0.7rem 1rem;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(25, 25, 25, 0.25);
  text-align: center;
  position: relative;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;

  img {
    height: 52px;
  }

  .block {
    position: relative;
    padding: 0;
    margin-bottom: 0;

    .headerleft {
      display: flex;
      justify-content: space-around;
      position: absolute;
      top: 50%;
      transform: (translateY(-50%));

      > a {
        color: #969696;
        transition: color .5s;
        display: flex;
        align-items: center;
        flex-direction: column;

        svg {
          fill: #969696;
          transition: fill .5s;
        }

        &:hover,
        &:focus {
          color: #004e9f;
          transition: color .5s;

          svg {
            fill: #004e9f;
            transition: fill .5s;
          }
        }

        p {
          margin-top: 5px;
          display: none;
          font-size: 13px;
        }
      }
    }
  }

  .headerright {
    display: flex;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: (translateY(-50%));
    color: #969696;

    .language-toggle {
      gap: 5px;
      display: flex;

      .lang-link {
        color: #969696;

        &.current-lang {
          font-weight: 600;
        }

        &:hover {
          color: #004e9f;
        }
      }
    }
  }
}

@media (min-width: 1000px) {
  .header .block .headerleft {
    right: 100%;

    a > p {
      display: block;
    }
  }
  .header .block .headerright {
    left: 100%
  }
}

@media (max-width: 999px) {
  .header .block .headerleft {
    left: 0;
  }
  .header .block .headerright {
    right: 0;
  }
}

@media (max-width: 680px) {
  .header {
    padding: 0.6rem 1rem 0.4rem 1rem;

    img {
      height: 35px;
    }

  }
}
</style>


